


































































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ScientficProjectAddInfo from '../scientficProjectAddInfo.vue'
import Appconst from '../../../../lib/appconst';
@Component({
    name:'scientficProjectDetail',
    components: {
        ScientficProjectAddInfo
    }
})
export default class ScientficProjectDetail extends AbpBase  {
    initData:any = {
        loading: true,
        resData: {},
        modalData: {
            status: false,
            loading: true
        },
        showAudit: false,
        submitFormData:{
            checkView:'',
            isArchieve:''
        }, // 提交表单
        isEdit:false, // 是否编辑
        userInfo:{}, // 当前用户信息
    }
    //显示编辑
    ShowEdit(status:boolean) {
        this.initData.isEdit = true;
        // 获取结题验收数据
        this.GetConcludCheck()
    }
    // 保存
    submitEdit() {
       let tempObj = Object.assign(this.initData.submitFormData);
        // 格式化
        tempObj.isArchieve = tempObj.isArchieve == '1' ? true : false;
        tempObj.id = this.initData.id;
        Ajax.put('/api/services/app/ResearchProject/UpdateConcludCheckAsync',tempObj)
            .then( async (res: any) => {
                if(res.data.success){
                    this.$Message.success('提交成功!');
                    this.initData.isEdit = false;
                    this.GetConcludCheck();
                }
            } )
            .catch( (err: any) => {
                   this.$Message.success('提交失败!');
            } )
    }
    async GetDic() {
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.initData.showAudit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.RM.C.Audit'];
    }
    // 获取结题验收数据
    GetConcludCheck() {
        Ajax.get('/api/services/app/ResearchProject/GetConcludCheckAsync?Id='+this.initData.id).then((res:any)=>{
            this.initData.submitFormData = res.data.result;
            //格式化
            this.initData.submitFormData.checkView = this.initData.submitFormData.checkView?String(this.initData.submitFormData.checkView):'';
            this.initData.submitFormData.isArchieve = this.initData.submitFormData.isArchieve?'1':'0';
        })
    }
    // 获取数据
    GetData() {
        this.initData.loading = true;
        Ajax.get('/api/services/app/ResearchProject/GetProjectDetailAsync?Id='+this.initData.id).then((res:any)=>{
            this.initData.resData = res.data.result;
            (this.$parent as any).SetName(res.data.result.projectName)
            this.initData.loading = false;
        })
    }
    async mounted() {
        this.initData.id = this.$route.query.id;
        await this.GetDic();
        this.GetData();
        // 获取结题验收数据
        this.GetConcludCheck()
        // 获取当前登录用户信息
        await this.$store.dispatch('project/GetAllUser');
        this.initData.userInfo = this.$store.state.session.user;
    }
}
